// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"d516240d","262":"11d6180b","476":"3773e1f7","488":"28058288","556":"95fe86d3"}[chunkId] + ".chunk.js";
};